// extracted by css-extract-rspack-plugin
export default {"button":"ContainedButton_button__I5AOK"};